import React, { useState } from "react";
import { MapPin } from "lucide-react";
import SectionHeading from "@/components/common/SectionHeading";
import MarketMap from "@/components/common/MarketMap";
import { Reveal, Stagger, StaggerItem } from "@/components/common/Reveal";
import { useSettings } from "@/context/SettingsContext";

export default function MarketsSection({ chapter = "04" }) {
  const { markets = [] } = useSettings();
  const [active, setActive] = useState(null);
  return (
    <section className="container-page py-20 lg:py-28" data-testid="markets-section" id="markets">
      <SectionHeading
        chapter={chapter}
        eyebrow="Markets"
        title="Connected to key international trade markets"
        intro="We coordinate enquiries involving selected sourcing and commercial markets across regions."
      />

      <div className="mt-12 grid gap-8 lg:grid-cols-12 items-start">
        <Reveal className="lg:col-span-6">
          <MarketMap markets={markets} activeCode={active} onHover={setActive} />
          <p className="mt-4 text-[13px] text-muted-foreground italic">
            Service areas shown do not necessarily represent company-owned offices.
          </p>
        </Reveal>

        <Stagger className="lg:col-span-6 grid sm:grid-cols-2 gap-px bg-[#D9E0E4] border border-[#D9E0E4] rounded-lg overflow-hidden">
          {markets.map((m) => (
            <StaggerItem key={m.code}>
              <div
                onMouseEnter={() => setActive(m.code)}
                onMouseLeave={() => setActive(null)}
                className={`h-full bg-white p-5 transition-colors ${active === m.code ? "bg-[#EAF1F4]" : ""}`}
                data-testid={`market-card-${m.code}`}
              >
                <div className="flex items-center gap-2">
                  <MapPin className="h-4 w-4 text-copper" />
                  <h3 className="font-heading font-bold text-[16px] text-navy">{m.name}</h3>
                </div>
                <p className="mt-1 text-[12px] font-semibold uppercase tracking-wide text-teal">{m.role}</p>
                <p className="mt-2 text-[13.5px] text-muted-foreground leading-relaxed">{m.note}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
